import { render, staticRenderFns } from "./MealsStudent.vue?vue&type=template&id=583203fc&scoped=true&"
import script from "./MealsStudent.vue?vue&type=script&lang=js&"
export * from "./MealsStudent.vue?vue&type=script&lang=js&"
import style0 from "./MealsStudent.vue?vue&type=style&index=0&id=583203fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583203fc",
  null
  
)

export default component.exports